<template>
  <section id="portfolio" class="dark-section">
    <div class="container-fluid">
      <h1 class="section-header">{{ heading }}</h1>
      <br>
      <div id="portfolio-container" class="row">
        <div v-for="filter in filters" :key="filter" class="col-12">
          <h2 class="section-header filter-title">{{ filter }}</h2>
          <div class="row">
            <div
              v-for="(item, index) in filteredProjectsByFilter(filter)"
              :key="index"
              class="col-sm-12 col-md-4 flex-col mb-4"
            >
              <div class="portfolio-card">
                <div class="portfolio-image">
                  <img :src="require(`../../assets/images/portfolio/${item.image}`)" rel="preload"/>
                </div>
                <div class="portfolio-content">
                  <h3>{{ item.title }}</h3>
                  <p class="project-description">{{ item.description }}</p>
                  <div class="portfolio-links">
                    <a :href="item.link" class="demo-btn" title="Live Demo" target="_blank">
                      <i class="fas fa-external-link-alt"></i> View Project
                    </a>
                    <a v-if="item.source !== '' && item.source != item.link" :href="item.source" class="source-btn" title="Source Code" target="_blank">
                      <i class="fas fa-code"></i> Source
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Arrow />
  </section>
</template>
<script>
import data from "../../data/data.json";
import Arrow from "../components/Arrow.vue";
export default {
  name: "portfolio",
  props: {},
  components: {
    Arrow,
  },
  data() {
    return {
      projects: data.portfolio.projects,
      heading: data.main.headings.portfolio,
    };
  },
  computed: {
    filters() {
      let filterList = [];
      this.projects.forEach((project) => {
        if (!filterList.includes(project.filter)) {
          filterList.push(project.filter);
        }
      });
      return filterList;
    },
  },
  methods: {
    filteredProjectsByFilter(filter) {
      return this.projects.filter((project) => project.filter === filter);
    },
  },
};
</script>
<style lang="scss">
.filter-title {
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-size: 2rem;
  color: white;
  text-transform: capitalize;
}

.portfolio-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  background-color: rgba(25, 25, 25, 0.8);
  box-shadow: 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }
  
  .portfolio-image {
    width: 100%;
    overflow: hidden;
    
    img {
      width: 100%;
      height: auto;
      display: block;
      transition: transform 0.3s ease;
    }
  }
  
  .portfolio-content {
    padding: 1.25rem;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    
    h3 {
      font-size: 1.3rem;
      margin-bottom: 0.75rem;
      color: white;
    }
    
    .project-description {
      color: #e0e0e0;
      margin-bottom: 1rem;
      flex-grow: 1;
    }
    
    .portfolio-links {
      display: flex;
      flex-wrap: wrap;
      gap: 0.75rem;
      justify-content: center;
      
      a {
        text-decoration: none;
        padding: 0.5rem 1rem;
        border-radius: 4px;
        font-weight: 500;
        transition: all 0.2s ease;
        display: inline-flex;
        align-items: center;
        
        i {
          margin-right: 0.5rem;
        }
      }
      
      .demo-btn {
        background-color: #a334db;
        color: white;
        
        &:hover {
          background-color: rgb(139, 41, 185);
        }
      }
      
      .source-btn {
        background-color: #2c3e50;
        color: white;
        
        &:hover {
          background-color: #1a2530;
        }
      }
    }
  }
}
</style>